module.exports = __webpack_public_path__ + "static/media/logo_qa.23e43619.svg";